<template>
  <v-container class="py-15" id="videos">
    <LoadingWidget v-if="loading" />
    <template v-else>
      <TitleWidget>Vídeos</TitleWidget>

      <v-container class="py-10 px-md-4" fluid>
        <v-row class="mx-md-n4 position-relative">
          <v-col cols="12" lg="8" offset-lg="2">
            <CarouselWidget
              v-if="items.length"
              class="carousel-videos"
              :items="items"
              :itemsToShow="{
                xs: 2,
                sm: 3,
                md: 4,
                lg: 3,
                xl: 3,
              }"
              :gap="20"
              nav
            >
              <template #item="{ item }">
                <iframe
                  :src="`https://www.youtube.com/embed/${item.id}?autoplay=0&loop=1&playlist=${item.id}`"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen
                ></iframe>
              </template>
            </CarouselWidget>
          </v-col>
        </v-row>
      </v-container>
    </template>
  </v-container>
</template>

<script>
import TitleWidget from "../widgets/TitleWidget.vue";
import CarouselWidget from "../widgets/CarouselWidget/Index.vue";
import LoadingWidget from "../widgets/LoadingWidget.vue";

const _config = {
  mod: "videos",
};

export default {
  data() {
    return {
      loading: true,
    };
  },
  computed: {
    items() {
      return this.$rest(_config.mod).list.map((item) => {
        const linkVideo = item.link.split("/");
        const idVideo = linkVideo[linkVideo.length - 1];
        return {
          id: idVideo,
        };
      });
    },
  },
  created() {
    this.$rest(_config.mod)
      .get()
      .finally(() => (this.loading = false));
  },
  components: {
    TitleWidget,
    CarouselWidget,
    LoadingWidget,
  },
};
</script>

<style lang="scss" scoped>
iframe {
  width: 100%;
  height: 100%;
  aspect-ratio: 9 / 16;
  border-radius: 20px;
}
</style>
